import { useMutation } from '@tanstack/react-query';

import { handleError } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApplicationForm } from '../../requests/getApplicationForm';

export const useApplicationFormLoader = (definitionName: string) => {
  const { constructGet } = useRequestConstructor();

  const { mutateAsync: loadForm, ...rest } = useMutation({
    mutationFn: ({ uuid, formKey }: { uuid: string; formKey: string }) =>
      getApplicationForm(constructGet, uuid, definitionName, { form: formKey }),
    onError: () => handleError('Could not load form.'),
  });

  return { loadForm, ...rest };
};
